import { render } from "./VBadge.vue?vue&type=template&id=2567ceea"
import script from "./VBadge.vue?vue&type=script&lang=js"
export * from "./VBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__